import React, { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography } from "@mui/material";
import ColorInfo from "./ColorInfo";
import { useQuestionNavigator } from "../../../hooks/default/useQuestionNavigator";
import { useQuestionRecord } from "../../../context/QuestionRecord";

function SideBar({
  subjects,
  setCurrentQuestion,
  setCurrentSubject,
  setSubjectId,
  currentQuestion,
  questionData,
  setCurrentQuestionBySubject,
  toggleSubject,
  expandedSubject,
  setExpandedSubject,
}) {
  // ✅ Function to calculate global question index
  const getGlobalIndex = (subjectIndex, questionIndex, subjectId) => {
    let offset = 0;

    for (let j = 0; j < subjectIndex; j++) {
      offset += subjects[j].subject_question_count;
    }

    setCurrentSubject(expandedSubject);
    setSubjectId(subjectId);
    return offset + questionIndex;
  };
  // "notVisited"
  // not answered
  // "attempted"
  // "marked"

  const {
    questions,
    answered,
    marked,
    notVisited,
    notAnswered,
    markedWithAnswered,
    visitedQuestions,
  } = useQuestionNavigator({
    currentQuestion,
    questionData,
  });

  const { getQuestionRecordById } = useQuestionRecord();
  // attempt_status

  const statusColor = (id) => {
    const attempt_status = getQuestionRecordById(id)?.attempt_status;

    switch (attempt_status) {
      case "attempted":
        return "blue";
      case "marked":
        return "purple";
      case "not answered":
        return "#d1d1d1ff";
      default:
        return "white";
    }
  };

  return (
    <div
      style={{
        width: "22%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          maxHeight: "calc(100vh - 150px)",
          overflow: "auto",
        }}
      >
        {subjects?.map((subject, subjectIndex) => (
          <div key={subject.id} style={{ borderBottom: "1px solid black" }}>
            {/* Header with toggle */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
                cursor: "pointer",
                backgroundColor:
                  expandedSubject === subject.subject_name
                    ? "#d6d5d5ff"
                    : "#f9f9f9",
                transition: "background 0.3s ease",
              }}
              onClick={() => toggleSubject(subject.subject_name)}
            >
              <Typography>{subject.subject_name}</Typography>
              {expandedSubject === subject.subject_name ? (
                <ExpandMoreIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </div>

            {/* Collapsible question list */}
            {expandedSubject === subject.subject_name && (
              <div
                style={{
                  padding: "10px",
                  // backgroundColor: "#f0f0f0",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                {subject.questions.map((que, i) => (
                  <Typography
                    key={i}
                    onClick={() => {
                      setCurrentQuestion(
                        getGlobalIndex(subjectIndex, i, que.subject_id)
                      );
                      setCurrentQuestionBySubject(i);
                    }}
                    style={{
                      border: "1px solid black",
                      padding: "4px 10px",
                      background: statusColor(que.id),
                      color:
                        statusColor(que.id) === "blue" ||
                        statusColor(que.id) === "purple"
                          ? "white"
                          : "black",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    {i + 1}
                  </Typography>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <ColorInfo
        answered={answered}
        marked={Number(marked) + Number(markedWithAnswered)}
        notAnswered={notAnswered}
        visitedQuestions={visitedQuestions}
        notVisited={notVisited}
      />
    </div>
  );
}

export default SideBar;
